module.exports = __webpack_public_path__ + "img/horseracing 2.09519018.webp";